// extracted by mini-css-extract-plugin
export default {"recos":"b5-z","productCardOverride":"c5-z","rowHasBadge":"d5-z"};